// extracted by mini-css-extract-plugin
export default {"dropdownHeader":"MessageCenter__dropdownHeader__yKUjN"};